import React from 'react';

import desktopWebp from 'assets/image/about_header_desktop.webp';
import desktopImg from 'assets/image/about_header_desktop.jpg';
import mobileWebp from 'assets/image/about_header_mobile.webp';
import mobileImg from 'assets/image/about_header_mobile.jpg';

import { Container, Img } from './styles';

const Snap1 = () => (
  <Container>
    <picture>
      <source srcSet={mobileWebp} type="image/webp" media="(orientation: portrait)" />
      <source srcSet={mobileImg} type="image/jpeg" media="(orientation: portrait)" />
      <source srcSet={desktopWebp} type="image/webp" media="(orientation: landscape)" />
      <source srcSet={desktopImg} type="image/jpeg" media="(orientation: landscape)" />
      <Img src={desktopImg} alt="background_image" />
    </picture>
  </Container>
);

export default Snap1;
